import React from 'react';

import { connect } from 'react-redux';

import {
    Popover,
    Button,
    Row,
    DatePicker,
    Select,
    Upload,
    message,
} from 'antd'

import {
    _getQbPaymentMethods,
    _getQbDepositToAccounts,
} from '../../services'

import { API_ENDPOINT, MKT_BASE_CURRENCY } from '../../index';

const { Option } = Select;
const productionEnvString = "production";

/**
 * This button purely uploads a payment advice image as well as 
 * depositToId and paymentMethodId to payment-advice Object
 */
class UploadButton extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            paymentMethods: false,
            depositToAccounts: false,

            popoverVisible: false,
        }
    }

    render() {
        return (
            this.renderPaymentAdviceButton()
        )
    }

    componentDidMount() {
        Promise.all([
            _getQbPaymentMethods(),
            _getQbDepositToAccounts(),
        ])
        .then( ([paymentMethodsRes, depositToAccountsRes]) => {
            const { paymentMethods } = paymentMethodsRes.data
            const { depositToAccounts } = depositToAccountsRes.data

            let paymentAdviceActivePaymentMethodId
            // process.env.NODE_ENV == productionEnvString?
            //     paymentMethods["Paypal"].Id
            //     :
            //     paymentMethods["Cash"].Id

            let paymentAdviceActiveDepositToId
            // process.env.NODE_ENV == productionEnvString?
            //     depositToAccounts["UOB Current"].Id
            //     :
            //     depositToAccounts["Inventory"].Id

            this.setState({
                paymentMethods,
                depositToAccounts,
                paymentAdviceActivePaymentMethodId,
                paymentAdviceActiveDepositToId
            })

        })
    }

    renderPaymentAdviceButton = () => {
		return (
            <Popover
                trigger="click"
                placement="bottom"
                content={this.renderPaymentAdviceUploadForm()}
                visible={this.state.popoverVisible}
                >
                <Button
                    onClick={()=>this.setState({popoverVisible: !this.state.popoverVisible})}
                    >Verify</Button>
            </Popover>
		)

    }

    renderPaymentAdviceUploadForm = () => {
        const { paymentMethods, depositToAccounts } = this.state;
        const { paymentAdviceId, entityId, entityType } = this.props;

		return(
			<React.Fragment>
                <Row type="flex" justfiy="start">
                    Payment Method
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Select 
                    placeholder="Payment Method"
                    value={this.state.paymentAdviceActivePaymentMethodId}
                    onChange={(val) =>this.setState({paymentAdviceActivePaymentMethodId:val})}
                    style={{width:150}}>
                        {Object.keys(paymentMethods).map(_key =>
                        <Option value={paymentMethods[_key].Id}>
                            {paymentMethods[_key].Name}
                        </Option>
                        )}
                    </Select>
                </Row>
                <Row type="flex" justfiy="start">
                    Deposit to
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Select 
                    value={this.state.paymentAdviceActiveDepositToId}
                    placeholder="Deposit to"
                    onChange={(val) =>this.setState({paymentAdviceActiveDepositToId:val})}
                    style={{width:150}}>
                        {Object.keys(depositToAccounts).map(_key =>
                        <Option value={depositToAccounts[_key].Id}>
                            {depositToAccounts[_key].Name}
                        </Option>
                        )}
                    </Select>
                </Row>
                {/* <Row type="flex" justfiy="start">
                    Payment Date
                </Row> */}
                {/* <Row style={{marginBottom:8}} type="flex" justify="center">
                    <DatePicker
                        style={{width: 150}}
                        onChange={(date) =>this.setState({paymentAdviceDate: date})}
                    />
                </Row> */}
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Upload
                        withCredentials
                        data={{
                            depositToId: JSON.stringify(this.state.paymentAdviceActiveDepositToId),
                            paymentMethodId: JSON.stringify(this.state.paymentAdviceActivePaymentMethodId),
                            paymentAdviceId: JSON.stringify(paymentAdviceId),
                            entityId: JSON.stringify(entityId),
                            entityType: JSON.stringify(entityType),
                            uploadedById: JSON.stringify(this.props.user.data._id),
                            uploadedByEmail: JSON.stringify(this.props.user.data.local.email),
                            mktBaseCurrency: JSON.stringify(MKT_BASE_CURRENCY)
                        }}
                        action={`${API_ENDPOINT}/api/admin/order-docs/verify-payment-advice`}
                        onChange={ (info) => this.handleOnChangeUploadPaymentAdvice(info) }
                        >
                        <Button
                            style={{width:150}}
                            disabled={!this.state.paymentAdviceActivePaymentMethodId || !this.state.paymentAdviceActiveDepositToId}
                            type="primary">Upload</Button> 
                    </Upload>
                </Row>
			</React.Fragment>
		)
    }

    handleOnChangeUploadPaymentAdvice = (info) => {
		if(info.file.status === "done" && info.file.response.success){
            message.success(`Payment Advice Verified`)
            this.props.getPaymentAdvice()
		}

		if(info.file.status === "error"){
			message.error(`Error verifying payment advice`, 10)
		}
	}

}

export default connect(
    state => ({
		user: state.user
	}),
)(UploadButton)


// WEBPACK FOOTER //
// ./src/components/payment-advice/upload-button.js